import { useContext, useState } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';
import ConfirmModal from '../components/ConfirmModal';

export default function IndustriesEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.industries);
  useUnsavedChanges(isDirty);

  const [deleteIdx, setDeleteIdx] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const handleSave    = () => save(patch => updateSection('industries', patch));
  const handleDiscard = () => discard(content.industries);

  const items = draft.items || [];
  const item  = items[activeTab] || {};

  const updateItem = (patch) =>
    update({ items: items.map((t, i) => i === activeTab ? { ...t, ...patch } : t) });

  const addItem = () => {
    update({ items: [...items, { name: 'New Industry', bullets: [] }] });
    setActiveTab(items.length);
  };

  const removeItem = (i) => {
    update({ items: items.filter((_, idx) => idx !== i) });
    setActiveTab(Math.max(0, activeTab - 1));
  };

  return (
    <div className="adm-page">
      <AdminTopbar title="Industries" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      {deleteIdx !== null && (
        <ConfirmModal
          message={`Delete industry "${items[deleteIdx]?.name}"?`}
          onConfirm={() => { removeItem(deleteIdx); setDeleteIdx(null); }}
          onCancel={() => setDeleteIdx(null)}
        />
      )}

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Section Heading</h3>
          <div className="adm-field">
            <label className="adm-label">Heading</label>
            <input className="adm-input" value={draft.heading || ''}
              onChange={e => update({ heading: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Industry Tabs</h3>

          <div className="adm-tabs">
            {items.map((t, i) => (
              <button key={i}
                className={`adm-tab${i === activeTab ? ' adm-tab--active' : ''}`}
                onClick={() => setActiveTab(i)}>
                {t.name || `Tab ${i + 1}`}
              </button>
            ))}
            <button className="adm-tab adm-tab--add" onClick={addItem}>+ Add</button>
          </div>

          {items.length > 0 && (
            <div className="adm-tab-content">
              <div className="adm-field" style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                <div style={{ flex: 1 }}>
                  <label className="adm-label">Industry Name</label>
                  <input className="adm-input" value={item.name || ''}
                    onChange={e => updateItem({ name: e.target.value })} />
                </div>
                <button className="adm-btn adm-btn--danger adm-btn--sm"
                  onClick={() => setDeleteIdx(activeTab)}>Delete</button>
              </div>

              <div className="adm-field">
                <label className="adm-label">Bullet Points (one per line)</label>
                <textarea className="adm-textarea" rows={5}
                  value={(item.bullets || []).join('\n')}
                  onChange={e => updateItem({ bullets: e.target.value.split('\n') })} />
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
